import React from 'react';
import AlarmLevelStatistics from '../AlarmLevelStatistics';
import AlarmTimesRanking from '../AlarmTimesRanking';
import AlarmTypeDistribution from '../AlarmTypeDistribution';
import EachAreaAlarmRanking from '../EachAreaAlarmRanking';
import HighDeviceAlarmRanking from '../HighDeviceAlarmRanking';
import styles from './index.module.scss';

const EachAlarmDetails = () => {
  return (
    <div className={styles.content_wrapper}>
      <div className={styles.col_wrapper}>
        {/* 报警等级统计 */}
        <div className={styles.col_row}>
          <AlarmLevelStatistics />
        </div>
        {/* 高频设备报警排名 */}
        <div className={styles.col_row}>
          <HighDeviceAlarmRanking />
        </div>
      </div>
      <div className={styles.col_wrapper}>
        {/* 报警类型分布 */}
        <div className={styles.col_row}>
          <AlarmTypeDistribution />
        </div>
        {/* 各区域报警排名 */}
        <div className={styles.col_row}>
          <EachAreaAlarmRanking />
        </div>
      </div>
      {/* 持续报警时长排名 */}
      <div className={styles.col_wrapper_line}>
        <AlarmTimesRanking />
      </div>
    </div>
  );
};

export default EachAlarmDetails;
